export const presetProducts = [
    // Additional dummy products can be added here
];